import { createDataSelectors } from "@app/modules/app.reducers";
import { Localization } from "@ea/shared_types/types";

export const localizationDataSelectors = createDataSelectors<Localization>()("localization");
